import React, { useCallback, useMemo } from 'react';
import { CreateRelationshipButton } from '../../../../../modernization-common/relationships/components/create-relationship-button';
import { useRelationshipsEnabled } from '../../../hooks/use-relationships-enabled';
import { useRelationshipHandlers } from './use-relationship-handlers';
export const useCreateRelationshipComponent = () => {
  const isNewRelationshipsFeatureEnabled = useRelationshipsEnabled();
  const {
    createRelationshipWithEditableSource
  } = useRelationshipHandlers();
  const handleCreateRelationship = useCallback(() => {
    createRelationshipWithEditableSource();
  }, [createRelationshipWithEditableSource]);
  return useMemo(() => {
    return isNewRelationshipsFeatureEnabled ? () => <CreateRelationshipButton onClick={handleCreateRelationship} /> : undefined;
  }, [handleCreateRelationship, isNewRelationshipsFeatureEnabled]);
};